import { Badge, Box, HStack, Icon, Text } from '@chakra-ui/react'
import { InformationCircleIcon } from '@heroicons/react/solid'
import { TimeZone, Tour } from 'src/types/schema/graphql'
import TourHours from './TourHours'

interface ITourDetails {
    tourDetails: Tour
    timezone: TimeZone
}

const TourDetails: React.FC<ITourDetails> = ({ tourDetails, timezone }) => {
    return (
        <Box>
            <HStack spacing={3}>
                <Text fontSize={24} fontWeight={700}>
                    Tours
                </Text>
                {tourDetails?.cost && (
                    <Badge
                        fontSize={14}
                        bg={'gray.50'}
                        borderRadius={14}
                        paddingY={1}
                        paddingX={2}
                        _hover={{
                            bg: 'gray.50',
                        }}
                    >
                        ${tourDetails?.cost.toFixed(2)}
                    </Badge>
                )}
                {tourDetails?.mustBeLegalDrinkingAge && (
                    <HStack>
                        <Icon as={InformationCircleIcon} />
                        <Text fontWeight={600} fontSize={12}>
                            Must be legal drinking age.
                        </Text>
                    </HStack>
                )}
            </HStack>
            {tourDetails?.description && (
                <Text fontSize={16} fontWeight={500} my={6} color={'gray.500'}>
                    {tourDetails?.description}
                </Text>
            )}
            <TourHours hours={tourDetails?.hours} timezone={timezone} />
        </Box>
    )
}

export default TourDetails
